import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc AuthFlowCallerIdentificationStep defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AuthFlowCallerIdentificationStepService } from 'services/authFlowCallerIdentificationStep';
 *
 * // create service instance and send/cancel request
 * const authFlowCallerIdentificationStepService = new AuthFlowCallerIdentificationStepService();
 * const result = await authFlowCallerIdentificationStepService.fetchData( '<user-id>' ); // fetch data
 * authFlowCallerIdentificationStepService.cancel(); // cancel an active request
 */
export class AuthFlowCallerIdentificationStepService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const tabs = get( response, 'body.component.structure.tabs', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    tabs: getVisibleItems( tabs, visibility ),
                    navActions,
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // move to next step
    async moveToNextStep( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: { callId: '221' },
                    data: data,
                },
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: null,
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
